var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batchButton"},[_c('pendant',{attrs:{"titleName":"请填写游客信息"}}),_c('div',{staticClass:"button-box"},[_c('button',{staticClass:"batch",on:{"click":_vm.clickBatch}},[_vm._v("批量导入")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }